import axios from './axiosService';
import {orderBy} from 'lodash';

export default {
  getStatusCodes() {
    return [
      {id: 'Draft', name: 'Draft'},
      {id: 'Active', name: 'Active'},
      {id: 'Missing', name: 'Missing'},
      {id: 'Replaced', name: 'Replaced'},
      {id: 'Removed', name: 'Removed'},
    ]
  },
  getGeneratingStatusFor(presentationID) {
    return axios.get(`/api/presentations/${presentationID}/slides/generating-status`)
      .then(response => response.data);
  },
  /**
   * Return the Slides associated with a presentation.
   * This returns Slides, not Presentation Slides.
   * @param presentationID
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  getSlidesForPresentation(presentationID) {
    const form = {
      presentation_id: presentationID,
    }
    return axios.post(`/api/slides/search`, form)
      .then(response => response.data);
  },
  resetSlideMetadataFor(presentationID) {
    return axios.post(`/api/presentations/${presentationID}/slides/reset-metadata`)
      .then(response => response.data);
  },
  generateSlidesFor(presentationID) {
    return axios.post(`/api/presentations/${presentationID}/slides/generate`)
      .then(response => response.data);
  },
  changeSlideStatus(slideID, status) {
    return axios.patch(`/api/slides/${slideID}/status`, {status})
      .then(response => response.data);
  },
  replaceSlide(slideID, replacementID) {
    return axios.patch(`/api/slides/${slideID}/replace`, {replacement_id: replacementID})
      .then(response => response.data);
  },
  update(form, slideID) {
    return form.patch(`/api/slides/${slideID}`)
      .then(response => response.data);
  },
  getSlide(slideID) {
    return axios.get(`/api/slides/${slideID}`)
      .then(response => response.data);
  },
  getNotesForCurrentUser() {
    return axios.get(`/api/user/slide-notes`)
      .then(response => response.data);
  },
  getNote(slideNoteID) {
    return axios.get(`/api/slide-notes/${slideNoteID}`)
      .then(response => response.data);
  },
  createNote(form) {
    return form.post(`/api/slide-notes`)
      .then(response => response.data);
  },
  updateNote(slideNoteID, form) {
    return form.patch(`/api/slide-notes/${slideNoteID}`)
      .then(response => response.data);
  },
  deleteNote(slideNoteID) {
    return axios.delete(`/api/slide-notes/${slideNoteID}`)
      .then(response => response.data);
  },
  getUserNoteForSlide(userID, slideID) {
    const config = {
      params: {
        user_id: userID,
        slide_id: slideID,
      }
    }
    return axios.get(`/api/slide-notes`, config)
      .then(response => response.data);
  },
  getComparisonsFor(slideID) {
    return axios.get(`/api/slides/${slideID}/comparisons`)
      .then(response => response.data);
  },
  deleteUnnecessarySlides(presentationID) {
    return axios.delete(`/api/presentations/${presentationID}/slides/unnecessary`)
      .then(response => response.data);
  },
  /**
   * @param presentationID
   * @returns {Promise<Object[]>}
   */
  getPresentationSlidesFor(presentationID) {
    return axios.get(`/api/presentations/${presentationID}/slides`)
      .then(response => orderBy(response.data, ['position', 'id'], ['asc', 'asc']));
  },
  /**
   * Return the slide decks that belong to the current user.
   * @param {Form} form
   * @returns {*}
   */
  getSlideDecks(form) {
    return form.get(`/api/user/slide-decks`)
      .then(response => response.data);
  },
  /**
   * @param {Form} form
   * @returns {*}
   */
  getSlideDecksForCurrentUser(form) {
    return form.get(`/api/user/slide-decks`)
      .then(response => response.data);
  },
  getSlideDecksWithSlidesFrom(presentationID) {
    const config = {
      params: {
        presentation_id: presentationID,
      }
    }
    return axios.get(`/api/slide-decks/search`, config)
      .then(response => response.data);
  },
  updateSlideDeck(presentationID) {
    return axios.put(`/api/slide-decks/${presentationID}`)
      .then(response => response.data);
  },
  updateAllFrom(presentationID) { // MLD-7331
    return axios.post(`/api/presentations/${presentationID}/slide-decks/update-all`)
      .then(response => response.data);
  }
}
